export const adaptOperatorAcknowledgement = (response: Response): Response =>
  response.status === 202
    ? new Response('', {
        status: 200,
        headers: { 'Content-Type': 'text/event-stream' },
      })
    : response
